import React from 'react';
import MobileApp from './components/pwa/MobileApp';
import { ThemeContextProvider } from './styles/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { GlobalStyle } from './styles/GlobalStyle';
import './styles/App.css';
import './styles/Styles.css';

export default function App() {
    return (
        <AuthProvider>
            <ThemeContextProvider>
                <GlobalStyle />
                <MobileApp />
            </ThemeContextProvider>
        </AuthProvider>
    );
}